export default __webpack_public_path__ + "static/media/francheville05.631bfe40.jpg";